import React from "react";
import { BsFacebook, BsInstagram } from "react-icons/bs";

const Footer: React.FC = () => {
  return (
    <footer className="w-full py-12 pt-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8 lg:px-20">
        {/* Upper Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:gap-20 gap-12">
          {/* Description Section */}
          <div className="flex flex-col items-start max-w-md">
            <h3
              className="text-xl font-bold text-gray-800"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              Lada Basteskår
            </h3>
            <p
              className="text-left text-anotherGray mt-4"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              En plats där träning och gemenskap möts. Vi erbjuder funktionell
              träning, gruppträning och massage anpassade för att hjälpa dig att
              nå dina mål, oavsett nivå.
            </p>
            <p
              className="text-left text-anotherGray mt-4"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              Vår vision är att göra träning tillgänglig för alla – rolig,
              varierande och utmanande.
            </p>

            {/* Social Media */}
            <div className="flex space-x-3 mt-8">
              <a
                href="https://www.facebook.com/ladabasteskar"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-facebook transition"
              >
                <BsFacebook size={24} />
              </a>
              <a
                href="https://www.instagram.com/lada_basteskar?igsh=dThzbWluNXJ1Z2gw"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-instagram transition"
              >
                <BsInstagram size={24} />
              </a>
            </div>
          </div>

          {/* Link Section */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 md:gap-16 gap-12 text-left text-sm"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            {/* Services Links */}
            <div>
              <h3 className="text-base font-semibold text-gray-800 mb-6">
                Tjänster
              </h3>
              <ul className="space-y-4">
                <li>
                  <a
                    href="/schema"
                    className="text-anotherGray hover:text-gray-800 transition"
                  >
                    Schema
                  </a>
                </li>
                <li>
                  <a
                    href="/klasser"
                    className="text-anotherGray hover:text-gray-800 transition"
                  >
                    Gruppträning
                  </a>
                </li>
                <li>
                  <a
                    href="/massage"
                    className="text-anotherGray hover:text-gray-800 transition"
                  >
                    Massage
                  </a>
                </li>
              </ul>
            </div>

            {/* Information Links */}
            <div>
              <h3 className="text-base font-semibold text-gray-800 mb-6">
                Information
              </h3>
              <ul className="space-y-4">
                <li>
                  <a
                    href="/omoss"
                    className="text-anotherGray hover:text-gray-800 transition"
                  >
                    Om oss
                  </a>
                </li>
                <li>
                  <a
                    href="/kontakt"
                    className="text-anotherGray hover:text-gray-800 transition"
                  >
                    Kontakt
                  </a>
                </li>
                <li>
                  <a
                    href="/boka"
                    className="text-anotherGray hover:text-gray-800 transition"
                  >
                    Boka
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Lower Section */}
        <div className="mt-12 text-center text-xs text-gray-500">
          Webbplats utvecklad av Tim Olsson © 2024
        </div>
      </div>
    </footer>
  );
};

export default Footer;
